export default "__VITE_ASSET__DwcE_vvc__"